var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { Tooltip } from '@material-ui/core';
import React, { useState } from 'react';
import { FilterIcon } from '../../Components/Icons';
import { iconLight, primary } from '../../Styles/Colours';
import styles from './MedicationSummaryHeader.module.css';
import { Button, ButtonMode } from '../../Components/Button';
import { DecisionSupportWarningAlert } from '../../DecisionSupportWarningAlert';
import { PrescriberDetailsWarning } from '../../Components/PrescriberDetailsWarning';
import { SummaryHeaderActionsButtons } from './SummaryHeaderActionsButtons';
import { Bar } from './Bar';
export var MedicationSummaryHeader = function (props) {
    var _a = __read(useState(true), 2), showWarning = _a[0], setShowWarning = _a[1];
    return (React.createElement("div", null,
        React.createElement("div", { className: styles.header },
            React.createElement("div", { className: styles.title }, "Medication"),
            React.createElement(Bar, null),
            React.createElement(SummaryHeaderActionsButtons, { numberOfDraftMedications: props.numberOfDraftMedications, onReview: props.onReview, onFinaliseMedication: props.onFinaliseMedication, stopMedication: props.stopMedication, represcribeMedication: props.represcribeMedication, showMedicationsBrowser: props.showMedicationsBrowser }),
            React.createElement(Bar, { styles: { marginRight: 4 } }),
            React.createElement("div", { className: styles.bar }),
            React.createElement(Tooltip, { title: 'Filter', placement: 'bottom' },
                React.createElement("span", { className: styles.iconButton },
                    React.createElement(Button, { testId: 'button-filter', onClick: function () { return props.onFilterOpen(!props.filterOpen); }, mode: ButtonMode.text, iconOnly: true, noShadowOnHover: true, subtleShadeOnHover: true },
                        React.createElement(FilterIcon, { color: props.filterOpen ? primary : iconLight }))))),
        React.createElement(DecisionSupportWarningAlert, { noBorder: true }),
        React.createElement(PrescriberDetailsWarning, { showWarning: showWarning, onShowWarningClose: function () { return setShowWarning(false); }, goToEncounterFinaliseRoute: props.goToEncounterFinaliseRoute, getProviderRoute: props.getProviderRoute, serviceAuthorisationSystem: props.service.authoringSystem, serviceAuthorisationSystemForeignKey: props.service.authoringSystemForeignKey })));
};
